/**
 * Image optimization utilities for better performance
 */

// Base64 blur placeholder for images
export const shimmer = (w: number, h: number) => `
<svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="g">
      <stop stop-color="#f3f4f6" offset="20%" />
      <stop stop-color="#e5e7eb" offset="50%" />
      <stop stop-color="#f3f4f6" offset="70%" />
    </linearGradient>
  </defs>
  <rect width="${w}" height="${h}" fill="#f3f4f6" />
  <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
  <animate attributeName="x" from="-${w}" to="${w}" dur="1s" repeatCount="indefinite"  />
</svg>`

export const toBase64 = (str: string) =>
  typeof window === 'undefined'
    ? Buffer.from(str).toString('base64')
    : window.btoa(str)

// Generate blur placeholder data URL
export const getBlurDataURL = (width: number = 700, height: number = 475) => {
  return `data:image/svg+xml;base64,${toBase64(shimmer(width, height))}`
}

// Common image sizes for responsive images
export const imageSizes = {
  hero: {
    sizes: "100vw",
    width: 1920,
    height: 1080,
  },
  gallery: {
    sizes: "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw",
    width: 800,
    height: 600,
  },
  thumbnail: {
    sizes: "(max-width: 768px) 50vw, (max-width: 1024px) 33vw, 25vw",
    width: 400,
    height: 300,
  },
  profile: {
    sizes: "(max-width: 768px) 192px, 192px",
    width: 192,
    height: 192,
  },
  service: {
    sizes: "(max-width: 1024px) 100vw, 50vw",
    width: 600,
    height: 400,
  }
}

// Pre-defined blur data URLs for common sizes
export const blurDataURLs = {
  hero: getBlurDataURL(1920, 1080),
  gallery: getBlurDataURL(800, 600),
  thumbnail: getBlurDataURL(400, 300),
  profile: getBlurDataURL(192, 192),
  service: getBlurDataURL(600, 400),
}